import React from "react";
const Paginator = ({ dataPerPage, totalData, paginate, currentPage }) => {
   const pageNumbers = [];
   for (let i = 1; i <= Math.ceil(totalData / dataPerPage); i++) {
      pageNumbers.push(i);
   }

   return (
       <div className={" w-100"}>
         <div>
           <ul className="pagination  pt-1 pb-1 flex-wrap pagination-sm ">
             <li
               className="page-item pagination-sm"
               onClick={() => paginate(currentPage - 1)}
             >
               <a className="page-link" href="#">
                  <i className="bi bi-arrow-left"></i>
               </a>
             </li>
             {pageNumbers.map((number) => (
               <li
                 key={number}
                 onClick={() => paginate(number)}
                 className={`page-item  ${
                   number == currentPage ? "active" : ""
                 }`}
               >
                 <a className="page-link">{number}</a>
               </li>
             ))}
             <li
               className="page-item"
               onClick={() => paginate(currentPage + 1)}
             >
               <a className="page-link" href="#">
                  <i className="bi bi-arrow-right"></i>
               </a>
             </li>
           </ul>
         </div>
       </div>
   );

}

export default Paginator